import React from 'react';
import './LoadingEffect.scss';
import OlimpLogo from '../../assets/images/new_logo.png';

interface LoadingEffectProps {
    isVisible: boolean;
    isRightSide?: boolean;
}

const LoadingEffect: React.FC<LoadingEffectProps> = ({ isVisible, isRightSide }) => {
    return (
        <div className={`loading-effect ${isVisible ? 'loading-effect--visible' : ''} ${isRightSide ? 'loading-effect--right' : ''}`}>
            <div className="loading-effect__logo">
                <img src={OlimpLogo} alt="OLIMP" className="loading-effect__logo-image" />
                <div className="loading-effect__glow"></div>
            </div>
        </div>
    );
};

export default LoadingEffect; 